
define('template!popupCreatePrintZoneShareTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="detailed-info-form-container">\n  <div class="saving-label"></div>\n  <div class="error-label">' +
((__t = ( _.i18n('common.serverError') )) == null ? '' : __t) +
'\n    <div class="error-msg"></div>\n  </div>\n  <div class="form-horizontal">\n    <div class="form-inputs-container">\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('printzone.printer') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9 printers-auto-complete"></div>\n      </div>\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('printzone.imprinttechnology') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-9 imprint-technology-region"></div>\n      </div>\n      <div class="form-group">\n        <label class="col-xs-3 control-label">' +
((__t = ( _.i18n('common.width/height') )) == null ? '' : __t) +
'</label>\n        <div class="col-xs-4">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="width"\n                 placeholder="' +
((__t = ( _.i18n('common.width') )) == null ? '' : __t) +
'" value="' +
((__t = ( width )) == null ? '' : __t) +
'">\n        </div>\n        <div class="col-xs-4">\n          <input type="text" class="form-control floating-label js-info-input" data-field-name="height"\n                 placeholder="' +
((__t = ( _.i18n('common.height') )) == null ? '' : __t) +
'" value="' +
((__t = ( height )) == null ? '' : __t) +
'">\n        </div>\n      </div>\n      <div class="row">\n        <div class="pull-right p-r-15">\n          <button class="btn btn-default btn-flat cancel-b js-cancel">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n          <button class="btn btn-primary js-confirm">' +
((__t = ( _.i18n('common.confirm') )) == null ? '' : __t) +
'</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>';

}
return __p
};});

